<template>
	<v-row v-if="loading" no-gutters justify="center" align="center" style="height: 600px">
		<v-progress-circular
			:size="50"
			color="primary"
			indeterminate
		></v-progress-circular>
	</v-row>
	<ClinicHistory
		v-else
		:appointments="appointments"
		:patientAppointment="patientAppointment"
		:documents="documents"
		:patient="patient"
	/>
</template>

<script>
import ClinicHistory from "@/components/patient/ClinicHistory.vue";
import axios from "axios";

export default {
	name: "PatientClinic",
	props: ["patient"],
	components: {
		ClinicHistory
	},
	data: () => ({
		loading: true,
		appointments: [],
		documents: [],
		patientAppointment: { id: -1 }
	}),
	created() {
		axios
			.get("/patient/" + this.patient.id + "/history")
			.then(response => {
				console.log(response.data);
				if (response.status === 200) {
					this.loading = false;
					this.appointments = response.data.appointments;
					this.documents = response.data.documents;
				}
			})
			.catch(error => console.log(error));
	}
};
</script>